import { render, staticRenderFns } from "./_file-loader.vue?vue&type=template&id=45adbfd9&scoped=true"
import script from "./_file-loader.vue?vue&type=script&lang=js"
export * from "./_file-loader.vue?vue&type=script&lang=js"
import style0 from "./_file-loader.vue?vue&type=style&index=0&id=45adbfd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45adbfd9",
  null
  
)

export default component.exports